<template>
  <div class="print-box">
    <iframe class="iframe" id="pdfbox" frameborder="no" border="0"></iframe>
  </div>
</template>

<script>
var self;
export default {
  name: 'Print',
  data () {
    return {
      list:[]
    }
  },
  mounted () {
    self = this;
    if(localStorage.getItem("ExShopee_Pdfs")){
      self.list = JSON.parse(localStorage.getItem("ExShopee_Pdfs"));
      self.printPDF();
    }
  },
  methods:{
    printPDF () {
      var h = $(window).height();
      var w = $(window).width();
      var iframe = document.getElementById('pdfbox');
      $(".print-box").css({width:w+'px',height:h+'px'});
      iframe.src = self.list[0];
      iframe.style.width = w+'px';
      iframe.style.height = h+'px';
      setTimeout(function(){
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      },100)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .print-box{
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/logistics/Print.vue